<template>
  <div class="padding-20">
    <van-image
      v-if="cusUser.id!==undefined"
      width="100%"
      :src="cusUser.qrcode"
    />
  </div>
</template>

<script>
import Api from '@/utils/api'
export default {
  created () {
    this.reload()
  },
  data () {
    return {
      weiUser: {},
      cusUser: {}
    }
  },
  methods: {
    reload () {
      Api.post('wei.user/model', null, res => {
        this.weiUser = res.data
        if (res.data.cusUser !== undefined) this.cusUser = res.data.cusUser
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Qrcode.vue